import { connect } from 'react-redux';
import React, { useState } from 'react';
import { useResizeObserverRef } from '@sas/nova-commons/hooks/useResizeObserver';
import { PositionedLayout } from '../PositionedLayout';
import { exposeTestId } from '../../config';
import { Title } from '../Title';
const FlexHeightLayoutBase = (props) => {
    const [titleHeight, setTitleHeight] = useState(0);
    const [setTitleRef] = useResizeObserverRef((entry) => {
        setTitleHeight(entry.contentRect.height);
    });
    return (React.createElement(PositionedLayout, { style: Object.assign({ height: titleHeight + (props.childHeight || 0), minHeight: titleHeight + (props.childMinHeight || 0) }, props.style), id: props.id, autoLayout: true, onReportContextMenu: props.onReportContextMenu, "test-id": exposeTestId() ? props.id : undefined },
        React.createElement("div", { ref: setTitleRef },
            React.createElement(Title, { id: props.id })),
        props.children));
};
export const FlexHeightLayout = connect((state, props) => {
    const layoutData = state.ui.birdLayout.byId[props.id];
    const { minHeight = undefined, preferredHeight = undefined } = (layoutData && layoutData.constraints) || {};
    const { padding = 0, borderWidth = 0 } = (layoutData && layoutData.style) || {};
    const extraHeight = (padding + borderWidth) * 2;
    return {
        childMinHeight: minHeight !== undefined ? minHeight + extraHeight : undefined,
        childHeight: preferredHeight !== undefined ? preferredHeight + extraHeight : undefined,
    };
})(FlexHeightLayoutBase);
